import { render, staticRenderFns } from "./BudgetDashboardChart.vue?vue&type=template&id=01af14a4&scoped=true&"
import script from "./BudgetDashboardChart.vue?vue&type=script&lang=js&"
export * from "./BudgetDashboardChart.vue?vue&type=script&lang=js&"
import style0 from "./BudgetDashboardChart.vue?vue&type=style&index=0&id=01af14a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01af14a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01af14a4')) {
      api.createRecord('01af14a4', component.options)
    } else {
      api.reload('01af14a4', component.options)
    }
    module.hot.accept("./BudgetDashboardChart.vue?vue&type=template&id=01af14a4&scoped=true&", function () {
      api.rerender('01af14a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/BudgetDashboardChart.vue"
export default component.exports